
import React from "react";
import { Row, Col, Skeleton } from "antd";
import { VaultFile } from "@/types";
import FileCard from "./FileCard";

interface FileGridProps {
  files: VaultFile[];
  isLoading?: boolean;
  selectedIds: Set<string>;
  onFileClick: (file: VaultFile, e: React.MouseEvent) => void;
  onFileDoubleClick: (file: VaultFile) => void;
  onFileContextMenu: (file: VaultFile, e: React.MouseEvent) => void;
}

export default function FileGrid({
  files,
  isLoading = false,
  selectedIds,
  onFileClick,
  onFileDoubleClick,
  onFileContextMenu,
}: FileGridProps) {
  if (isLoading) {
    return (
      <div>
        <div className="section-label">FILES</div>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Col key={i} xs={12} sm={8} md={6} lg={6}>
              <Skeleton.Node active style={{ width: "100%", height: 140 }} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  if (files.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="section-label">FILES</div>
      <Row gutter={[16, 16]}>
        {files.map((file) => (
          <Col key={file.id} xs={12} sm={8} md={6} lg={6}>
            <FileCard
              file={file}
              isSelected={selectedIds.has(file.id)}
              onClick={(e) => onFileClick(file, e)}
              onDoubleClick={() => onFileDoubleClick(file)}
              onContextMenu={(e) => onFileContextMenu(file, e)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
